import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { compose, setDisplayName } from 'recompose';

import withConnectedData from './Container';
import LogoImg from './LogoImg';

export function Logo({
  brand,
  logoImageUrl,
}) {
  if (!logoImageUrl) {
    return <span />;
  }

  return (
    <Link to="/">
      <LogoImg src={logoImageUrl} alt={`${brand} logo`} />
    </Link>
  );
}

Logo.propTypes = {
  brand: PropTypes.string.isRequired,
  logoImageUrl: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

Logo.defaultProps = {
  logoImageUrl: undefined,
};

export default compose(
  setDisplayName('Logo'),
  withConnectedData,
)(Logo);



// WEBPACK FOOTER //
// ./compositions/Logo/index.js